import { createNextNavigation } from '@segway/core'

import { i18nRouting } from '@/config'

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } = createNextNavigation(i18nRouting)
